import { Claim } from 'interfaces';
import { create, StateCreator } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface SelectedClaimStore {
  selectedClaim: Claim | null;
  setSelectedClaim: (claim: Claim | null) => void;
  clearSelectedClaim: () => void;
  showPreview: boolean;
  setShowPreview: (show: boolean) => void;
  showClaimTotals: boolean;
  setShowClaimTotals: (show: boolean) => void;
}

const SelectedClaimStore: StateCreator<
  SelectedClaimStore,
  [['zustand/devtools', never], ['zustand/persist', unknown]]
> = (set) => ({
  selectedClaim: null,
  showPreview: false,
  showClaimTotals: true,
  setSelectedClaim: (claim) => set({ selectedClaim: claim }),
  clearSelectedClaim: () => set({ selectedClaim: null }),
  setShowPreview: (show) => set({ showPreview: show }),
  setShowClaimTotals: (show) => set({ showClaimTotals: show }),
});

export const useSelectedClaimStore = create<SelectedClaimStore>()(
  devtools(
    persist(SelectedClaimStore, {
      name: 'selected-claim-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        showPreview: state.showPreview,
        showClaimTotals: state.showClaimTotals,
      }),
      merge: (persistedState, currentState) => {
        const persisted = persistedState as Partial<SelectedClaimStore>;
        return {
          ...currentState,
          showPreview: persisted.showPreview ?? currentState.showPreview,
          showClaimTotals:
            persisted.showClaimTotals ?? currentState.showClaimTotals,
          selectedClaim: null,
        };
      },
    }),
    {
      name: 'SelectedClaimStore',
      store: 'SelectedClaimStore',
    }
  )
);

export default SelectedClaimStore;
